import { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Box,
  CircularProgress,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { generateMessage } from "../applicationAgentApi";

const AnswerQuestionSubform = ({
  alert,
  mcpToken,
  suggestedMessage,
  onSuggestedMessageChange,
  submitting,
  disabled,
  classes,
}) => {
  const [opsGuidance, setOpsGuidance] = useState("");
  const [generating, setGenerating] = useState(false);
  const [generateError, setGenerateError] = useState(null);

  const handleGenerate = async () => {
    setGenerating(true);
    setGenerateError(null);
    try {
      const result = await generateMessage(mcpToken, {
        sentimentAnalysisId: alert.sentimentAnalysisId,
        actionCategory: "answered_question",
        context: { ops_guidance: opsGuidance.trim() || undefined },
      });
      onSuggestedMessageChange(result.suggested_message);
    } catch (err) {
      setGenerateError(err.message || "Failed to generate message");
    } finally {
      setGenerating(false);
    }
  };

  return (
      <div className={classes.generateSection}>
        <Typography className={classes.label} variant="subtitle2">
          Suggested Response
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          label="Guidance for response (optional)"
          value={opsGuidance}
          onChange={(e) => setOpsGuidance(e.target.value)}
          disabled={submitting || disabled}
          placeholder="Describe what the response should say — leave blank to generate from conversation context alone"
          style={{ marginBottom: 8 }}
        />
        <Box mb={1}>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={handleGenerate}
            disabled={generating || submitting || disabled || !mcpToken}
          >
            {generating ? (
              <>
                <CircularProgress size={16} style={{ marginRight: 8 }} />
                Generating...
              </>
            ) : (
              "Generate Suggested Response"
            )}
          </Button>
        </Box>
        {generateError && (
          <Alert severity="error" style={{ marginBottom: 8 }}>
            {generateError}
          </Alert>
        )}
        <TextField
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          label="Message to applicant"
          value={suggestedMessage}
          onChange={(e) => onSuggestedMessageChange(e.target.value)}
          disabled={submitting || disabled}
          placeholder="Click 'Generate Suggested Response' or type a message manually"
        />
      </div>
  );
};

export default AnswerQuestionSubform;
